import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { useResourceContext } from 'ra-core';
import { useRateCalculations } from '../hooks/useRateCalculations';
import { DisplayHelpers } from 'utils/helpers';
import { getInheritedSettings } from '../PositionRateSettingsForm.utils';
import { useFormContext } from 'react-hook-form';

const INELIGIBLE_FOR_TEN_CENT_REDUCTION = ['AgencyLocationPositionRateSetting'];

type Props = {
  source: string;
  inheritedSettings: any;
};

export const ProfessionalRateInput = ({ source, inheritedSettings }: Props) => {
  const { handlers } = useRateCalculations({ source, inheritedSettings });
  const { watch } = useFormContext();
  const resource = useResourceContext();

  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });
  const show_ten_cent_reduction = !INELIGIBLE_FOR_TEN_CENT_REDUCTION.includes(resource);
  const { pro_rate_cents } = mergedSettings;

  return (
    <MoneyInput
      source={`${source}.pro_rate_cents`}
      label="Professional Rate"
      onChange={(event) => handlers.handleProfessionalRateChange(event.target.value)}
      helperText={
        show_ten_cent_reduction && `Adjusted rate: ${DisplayHelpers.money(pro_rate_cents - 10)}`
      }
    />
  );
};
